import React from 'react';
function CampusLife() {  return (
  <section id="campus">
    <div className="wrap">
      <div className="campus-head reveal">
        <div className="section-head" style={{margin: '0'}}>
          <div className="eyebrow">{'Campus Life'}</div>
          <h2>{'Beyond Classrooms. Beyond Limits.'}</h2>
          <p>
            {
              'From sports to music, from debates to community service — our students explore, excel and enjoy every moment.'
            }
          </p>
        </div>
        <a href="#campus" className="btn dark">
          {'Explore Campus Life\n        '}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
          >
            <path d="M5 12h14M13 6l6 6-6 6"></path>
          </svg>
        </a>
      </div>
      <div className="campus-grid reveal">
        <div className="campus-tile c2">
          <img
            src="/image/gallery/img1.JPG"
            alt="Students enjoying arts and music"
          />
          <span className="label">{'Arts & Music'}</span>
        </div>
        <div className="campus-tile c1">
          <img
            src="/image/gallery/img14.jpg"
            alt="Students taking part in sports and fitness"
          />
          <span className="label">{'Sports & Fitness'}</span>
        </div>
        <div className="campus-tile c3">
          <img
            src="/image/gallery/img12.jpg"
            alt="Students participating in clubs and activities"
          />
          <span className="label">{'Clubs & Activities'}</span>
        </div>
        <div className="campus-tile c4">
          <img
            src="/image/gallery/img15.JPG"
            alt="Students participating in community service"
          />
          <span className="label">{'Community Service'}</span>
        </div>
      </div>
    </div>
  </section>
);
}

export default CampusLife;
